import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'

export const FaqDescriptionWrapper = styled('div')(css`
  ${FontNormal(400)};
  ${fontSize(16)};
  color: #1A2433;
  margin-top: 22px;
`)

export const CollapseBtnWrapper = styled('div')(css`
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-bottom: 2px;
`)

export const collapseBtnStyles = css`
  display: flex;
  align-items: center;
  padding: 2px 10px;

  & > svg {
    width: 16px;
    height: 16px;
    margin-left: 5px;
  }
`
